<template>
  <header class="mobile-header" :class="{ 'is-home': route?.meta.menu_meta === 'overview' }">
    <div class="avatar">
      <!-- <router-link to="/settings"> -->
      <el-avatar :src="store.user?.avatar" id="js-onboarding-mobile-item-6" @click="userMenuDrawer = true" />
      <!-- </router-link> -->
    </div>
    <div class="center">
      <div class="select-storefront">
        <h2 class="heading" v-if="is_show_heading">{{ route?.meta.heading }}</h2>
        <el-dropdown v-else trigger="click" popper-class="storefronts-dropdown-menu">
          <span class="dropdown-trigger">
            <el-image :src="current_storefront?.brand_logo" fit="contain" class="dropdown-trigger-image" />
            <span class="dropdown-trigger-text">{{ current_storefront?.merchant_display_name }}</span> <svg-icon
              name="arrow" />
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                :class="[storefront.merchant_display_name === current_storefront?.merchant_display_name && 'storefronts-dropdown-menu-select']"
                v-for="storefront in storefronts" :key="storefront.id" @click="handleSelect(storefront)">
                <el-image class="avatar" :src="storefront.brand_logo" />
                <span>{{ storefront.merchant_display_name }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <h1>
        <router-link to="/" class="logo">
          <svg-icon name="logo-text" />
        </router-link>
      </h1>
    </div>
    <div class="actions">
      <router-link to="/" id="js-onboarding-mobile-item-5" @click="store.open_announcement = true;">
        <i class="icon" :class="{ 'show-count': store.unread_announcement_count !== 0 }"
          :data-count="store.unread_announcement_count > 9 ? '9+' : store.unread_announcement_count">
          <svg-icon name="bell" />
        </i>
      </router-link>
      <span @click="openMerchantList" id="js-onboarding-mobile-item-4">
        <i class="icon" :class="{ 'show-count': store.unread_count !== 0 }"
          :data-count="store.unread_count > 9 ? '9+' : store.unread_count">
          <svg-icon name="comments" />
        </i>
      </span>
    </div>
  </header>

  <footer class="mobile-footer-navi" v-if="route?.path !== '/preview-academy'">
    <ul>
      <li v-for="(menu, index) in menus" :key="menu.name" :class="{ actived: menu.meta === route?.meta.menu_meta }"
        :id="'js-onboarding-mobile-item-' + index">
        <router-link :to="menu.path">
          <i><svg-icon :name="menu.meta === route?.meta.menu_meta ? menu.icon_fill : menu.icon" /></i>
          <span>{{ menu.name }}</span>
        </router-link>
      </li>
    </ul>
  </footer>

  <el-drawer v-model="userMenuDrawer" class="user-menu-drawer" :show-close="false">
    <template #header>
      <div class="menu-drawer-header">
        <svg-icon name="arrow-prev" @click="userMenuDrawer = false" />
      </div>
    </template>

    <template #default>

      <div class="menu-drawer-content">
        <div class="user-menu-head">
          <el-avatar :src="store.user?.avatar" />
          <div class="user-menu-head-content">
            <h2 class="user-menu-head-name">{{ store.user?.display_name }}</h2>
            <p>/ {{ store.user?.user_handle }}</p>
          </div>
        </div>

        <div class="user-menu-list-box">
          <div class="user-menu-item" @click="goUrl('social-insights')">
            <svg-icon name="line" class="menu-item-icon" />
            <span>Social Insights</span>
          </div>
          <div class="user-menu-item" @click="goUrl('settings')">
            <svg-icon name="settings" class="menu-item-icon" />
            <span>Settings</span>
          </div>
          <div class="user-menu-item" @click="sendEmail()">
            <svg-icon name="feedback" class="menu-item-icon" />
            <span>Feedback/Support</span>
          </div>
        </div>

        <div class="user-menu-list-box">
          <div class="user-menu-section-header">
            <svg-icon name="terms" class="menu-item-icon" />
            <span>Terms and Policies</span>
          </div>
          <div class="user-menu-link" @click="openTerms()">
            <span>Creator Terms and Policies</span>
            <svg-icon name="menu-arrow" class="menu-link-arrow" />
          </div>
          <div class="user-menu-link" @click="openMerchantTerms()">
            <span>Terms and Services</span>
            <svg-icon name="menu-arrow" class="menu-link-arrow" />
          </div>
          <div class="user-menu-link" @click="openPrivacy()">
            <span>Privacy Policy</span>
            <svg-icon name="menu-arrow" class="menu-link-arrow" />
          </div>
          <div class="user-menu-link" @click="openCommunityGuidelines()">
            <span>Community Guidelines</span>
            <svg-icon name="menu-arrow" class="menu-link-arrow" />
          </div>
        </div>

        <el-button class="user-menu-logout" size="large" @click="store.logout()">
          LOG OUT
        </el-button>

        <p class="user-menu-footer">
          Powered by Motom<br />
          Copyright © 2025 Motom
        </p>
      </div>
    </template>
  </el-drawer>


  <el-drawer v-model="isShowMobileSidebar" class="mobile-sidebar" :show-close="false" size="100%">
    <template #header>
      <div class="mobile-sidebar-header">
        
        <h2  @click="isShowMobileSidebar = false"><svg-icon name="close" /> Message</h2>
      </div>
    </template>

    <template #default>
      <ul class="items">
        <li v-for="item in merchant_list" :key="item.merchant_account_id" :class="{ active: item.active }" @click="goTo(item);">
          <el-image :src="item.merchant_account.brand_logo" fit="contain" />
          <span>{{ item.merchant_account.merchant_display_name }}</span>
          <el-badge v-if="(item.unread_message_count + item.unread_announcement_count)" :value="(item.unread_message_count + item.unread_announcement_count)" :max="99" class="item"></el-badge>
          <i><svg-icon name="menu-arrow" /></i>
        </li>
      </ul>
    </template>
  </el-drawer>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { useGlobalStore } from '@/stores/GlobalStore';
import { useRoute, useRouter } from 'vue-router';
import emitter from '@shared/utils/EventBus';
import { useHandleCommen } from '@shared/components/ui/handleCommen';

const { toSlug } = useHandleCommen();
const route = useRoute();
const router = useRouter();
const store = useGlobalStore();
const storefronts = ref([]);
const isShowMobileSidebar = ref(false);
const current_storefront = ref({});
const merchant_list = ref([]);

const menus = ref([
  {
    name: 'Home',
    icon: 'home',
    icon_fill:'home-fill',
    path: '/',
    meta: 'overview',
  },
  {
    name: 'Manage',
    icon: 'store',
    icon_fill:'storefront-fill',
    path: '/manage',
    meta: 'manage',
  },
  {
    name: 'Analytics',
    icon: 'analytics',
    icon_fill:'analytics-fill',
    path: '/analytics-page',
    meta: 'analytics',
    sub_menus: [],
  },
  {
    name: 'Earnings',
    icon: 'pig',
    icon_fill:'earning-fill',
    path: '/earnings',
    meta: 'earnings',
  },
  // {
  //   name: 'Insights',
  //   icon: 'line',
  //   path: '/social-insights',
  //   meta: 'social-insights',
  // },]);
]);

const userMenuDrawer = ref(false);
const msg_url = ref('/messages');

const is_show_heading = computed(() => {
  return route && route.meta.menu_meta === 'overview' || route && (
    route.meta.menu_meta !== 'messages' &&
    route.meta.menu_meta !== 'analytics' &&
    route.meta.menu_meta !== 'manage'
  ) || storefronts.value.length === 0;
});

const goTo = item => {
  router.push({ path: '/messages/' + toSlug(item.merchant_account.merchant_display_name) });
  isShowMobileSidebar.value = false;
};

watch(
  () => route?.params.id,
  (id) => {
    if (store.user) {
      let storefront = store.user.merchant_accounts.find((storefront) => toSlug(storefront.merchant_display_name) === id);
      if (storefront) {
        current_storefront.value = storefront;
      }
    }
  }
);


//++++++++++++++++++++++++++++++++++++++++++++
const goUrl = (val) => {
  router.push({ name: val });
  userMenuDrawer.value = false
};

const sendEmail = () => {
  // window.location.href = "mailto:help@motom.me";
  emitter.emit('open-global-drawer', 'help-support');
};

const openPrivacy = () => {
  emitter.emit('open-global-drawer', 'privacy-policy');
};

const openTerms = () => {
  emitter.emit('open-global-drawer', 'terms-of-use');
};

const openMerchantTerms = () => {
  emitter.emit('open-global-drawer', 'terms-of-use');
};

const openCommunityGuidelines = () => {
  emitter.emit('open-global-drawer', 'community-guidelines');
};

const handleSelect = (storefront) => {
  let path = '';
  let name_url = toSlug(storefront.merchant_display_name);

  current_storefront.value = storefront;

  switch (route.meta.menu_meta) {
    case 'manage':
      path = '/manage/' + name_url + '/products';
      break;
    case 'analytics':
      path = '/analytics-page/' + name_url + '/overview';
      break;
    case 'messages':
      path = '/messages/' + name_url;
      break;
  }

  router.push(path);
};

const openMerchantList = () => {
  if (merchant_list.value.length === 1) {
    router.push({
      path: msg_url.value
    });
  } else {
    isShowMobileSidebar.value = true;
  }
};

const updateMenus = (user) => {
  if (user.merchant_accounts.length === 0) {
    return;
  }
  menus.value.forEach((menu) => {
    menu.is_active = menu.meta === route?.meta.menu_meta;
  });

  const url_name = toSlug(user.merchant_accounts[0].merchant_display_name);
  const manage_menu = menus.value.find((menu) => menu.meta === 'manage');
  manage_menu.path = '/manage/' + url_name + '/products';

  const analytics_menu = menus.value.find((menu) => menu.meta === 'analytics');
  analytics_menu.path = '/analytics-page/' + url_name + '/overview';

  storefronts.value = user.merchant_accounts;
  if (route?.params?.id) current_storefront.value = user.merchant_accounts.find((storefront) => toSlug(storefront.merchant_display_name) == route?.params.id);
  else current_storefront.value = user.merchant_accounts[0];

  store.getMerchantList().then(res => {
    // res.sort((a, b) => (b.unread_message_count + b.unread_announcement_count) - (a.unread_message_count + a.unread_announcement_count));
    merchant_list.value = res.map((item, index) => {
      item.id = item.merchant_account_id;
      if (route?.params.id && toSlug(item.merchant_account.merchant_display_name) == route.params.id) {
        item.active = true;
      } else {
        item.active = false;
      }
      return item;
    });

    if (merchant_list.value.length > 0) {
      // order by unread_message_count and unread_announcement_count
      merchant_list.value.sort((a, b) => (b.unread_message_count + b.unread_announcement_count) - (a.unread_message_count + a.unread_announcement_count));
      msg_url.value = '/messages/' + toSlug(merchant_list.value[0].merchant_account.merchant_display_name);
    }

    // console.log('merchant_list', merchant_list)

    // merchant_list.value = merchant_list;
  });

};

onMounted(() => {
  emitter.on('update-user-info', (data) => {
    updateMenus(data);
  });

  emitter.on('update-unread-count', () => {
    store.getMerchantList(true);
  });

  store.getUserMe().then((user) => {
    updateMenus(user);
  });

  emitter.on('toggle-mobile-sidebar', () => {
    isShowMobileSidebar.value = !isShowMobileSidebar.value;
  });
});
</script>

<style lang="scss">
@media screen and (max-width: $mobile_size) {
  html #app > .ui-container {
    padding-left: 0;
    display: block;

    &:after {
      content: '';
      display: block;
      clear: both;
      height: var(--mobile-footer-height);
      transition: all 0.3s ease;
    }

    .ui-main {
      overflow: visible;
      display: block;
    }

    .main-content {
      height: auto;
      margin-top: 0;
      border-radius: 0;
    }
  }
}

.mobile-header {
  height: var(--mobile-header-height);
  background-color: var(--Bg-light);
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  position: sticky;
  top: 0;
  z-index: 10;
  transition: all 0.3s ease;

  h1 {
    height: var(--mobile-header-height);
    background-color: var(--Bg-light);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    display: none;

    .logo {
      color: var(--Text-brand);
      width: 100px;
      height: 24px;
      position: relative;
      display: block;

      svg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
    }
  }

  .center {
    height: var(--mobile-header-height);
    position: relative;
    flex: 1;
    overflow: hidden;

    .select-storefront {
      height: var(--mobile-header-height);
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .dropdown-trigger {
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
      }

      .dropdown-trigger-image {
        width: 28px;
        height: 28px;
        margin-right: 8px;
        border-radius: var(--radius);
      }

      .dropdown-trigger-text {
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        max-width: calc(100vw - 280px);
      }

      .heading {
        font: var(--demi-22);
        color: var(--Text-primary);
      }

      .ui-dropdown {
        display: flex;
        align-items: center;
        justify-content: center;
        font: var(--demi-20);
        color: var(--Text-primary);

        svg {
          height: 10px;
          width: 10px;
          margin-left: 4px;
          transition: all 0.2s ease;
        }

        [aria-expanded='true'] {
          svg {
            transform: rotate(180deg);
          }
        }
      }
    }
  }

  .avatar {
    width: 60px;
    min-width: 60px;
    cursor: pointer;

    .ui-avatar {
      display: block;
      width: 30px;
      height: 30px;
      position: relative;
      top: 1px;
    }

    .ui-avatar {
      --ui-avatar-size: 30px;
    }
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    width: 60px;
    min-width: 60px;
    transition: all 0.3s ease;
    opacity: 0;
    pointer-events: none;

    span,
    a {
      height: 20px;
      width: 20px;
      display: flex;
      color: var(--Text-primary);
      cursor: pointer;
    }

    svg {
      width: 100%;
      height: 100%;
    }

    .show-count {
      position: relative;
    }

    .show-count::before {
      content: attr(data-count);
      position: absolute;
      top: 0px;
      right: 0px;
      padding: 0 5px 1px;
      text-align: center;
      background-color: var(--Red-30);
      color: white;
      border-radius: var(--radius-large);
      font: var(--medium-10);
      transform: translate(50%, -50%);
    }
  }

  &.is-home {
    .actions {
      opacity: 1;
      pointer-events: unset;
    }
  }
}

.mobile-footer-navi {
  height: var(--mobile-footer-height);
  background-color: var(--Bg-light);
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.1);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 101;
  padding: 0 8px;
  transition: all 0.3s ease;

  ul {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 25%;

      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: var(--Brand-primary);
        font-size: 10px;
        text-decoration: none;
        padding: 8px 12px 4px;
        border-radius: var(--radius);
        min-width: 68px;

        i {
          width: 18px;
          height: 18px;
          margin-bottom: 1px;
          display: block;
          position: relative;

          svg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);

            &.svg-icon__home {
              height: 115%;
              width: 115%;
            }
          }
        }

        span {
          display: block;
        }

        &:hover {
          color: var(--Brand-primary);
          background-color: var(--Black-05);
        }

        &:active {
          color: var(--Brand-primary);
          background-color: var(--Black-10);
        }
      }
      
      &.actived {
        a {
          color: var(--Brand-primary);
          background-color: var(--Black-10);
        }
      }
    }
  }
}

body.page-manage {
  // --mobile-header-height: 0px;
  --mobile-footer-height: 0px;

  .mobile-header .avatar {
    opacity: 0;
    pointer-events: none;
  }

  .mobile-footer-navi {
    bottom: -58px;
    opacity: 0;
  }

  html #app > .ui-container:after {
    display: none;
  }
}

.storefronts-dropdown-menu {
  .ui-scrollbar {
    width: 260px;
  }

  .ui-popper__arrow {
    display: none;
  }

  .ui-image {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    margin-right: 8px;

    img {
      object-fit: contain;
    }
  }

  .ui-dropdown-menu__item {
    padding: 6px 16px;

    &.storefronts-dropdown-menu-select {
      background-color: var(--Bg-02);
    }
  }
}

.user-menu-drawer {
  width: 100% !important;

  .ui-drawer__header {
    margin-bottom: 0;
    background-color: var(--Bg-01);
  }

  .menu-drawer-header {
    padding: 12px;

    svg {
      width: 16px;
      height: 16px;
      cursor: pointer;
      color: var(--Text-primary);
    }
  }

  .ui-drawer__body {
    background-color: var(--Bg-02);
  }

  .menu-drawer-content {
    padding: 16px;

    .user-menu-head {
      display: grid;
      grid-template-columns: 64px 1fr;
      gap: 16px;
      overflow: hidden;
      padding: 8px 0 16px;

      .ui-avatar {
        width: 64px;
        height: 64px;
        min-width: 64px;
        border-radius: var(--radius);
      }

      .user-menu-head-content {
        display: flex;
        flex-direction: column;
        justify-content: center;

        h2 {
          font: var(--demi-20);
          color: var(--Text-primary);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        p {
          color: var(--Text-default);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 4px 0 0;
        }
      }
    }

    .user-menu-list-box {
      background-color: var(--Bg-01);
      box-shadow: 0 1px 3px 0 rgba(63, 63, 68, 0.15), 0 0 0 1px rgba(63, 63, 68, 0.05);
      margin: 0 0 16px;
      padding: 8px 0;
      border-radius: var(--radius);
    }

    .user-menu-item {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      cursor: pointer;
      font: var(--medium-14);
      color: var(--Text-primary);
      transition: background-color 0.2s ease;

      .menu-item-icon {
        width: 24px;
        height: 24px;
        margin-right: 8px;
        flex-shrink: 0;
      }

      &:hover {
        background-color: var(--Bg-02);
      }
    }

    .user-menu-section-header {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      font: var(--demi-14);
      color: var(--Text-primary);

      .menu-item-icon {
        width: 24px;
        height: 24px;
        margin-right: 8px;
        color: var(--Text-default);
        flex-shrink: 0;
      }
    }

    .user-menu-link {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 16px;
      cursor: pointer;
      color: var(--Text-secondary);
      transition: background-color 0.2s ease;

      .menu-link-arrow {
        width: 16px;
        height: 16px;
        color: var(--Text-default);
        flex-shrink: 0;
        transform: rotate(-90deg);
      }

      &:hover {
        background-color: var(--Bg-02);
      }
    }

    .user-menu-logout {
      width: 100%;
      margin-top: 8px;
      font: var(--demi-14);
      border: 1px solid var(--Border-default);
      border-radius: var(--radius);
      height: 40px;
    }
  }

  .user-menu-footer {
    text-align: center;
    padding: 16px 0;
    background-color: var(--Bg-02);
    color: var(--Text-default);
    font-size: 12px;
    position: relative;

    a {
      color: var(--Text-default);
    }
  }
}

.mobile-sidebar {
  background-color: var(--Bg-01) !important;

  .ui-drawer__header {
    margin: 0;
  }

  .mobile-sidebar-header {
    height: 48px;
    background-color: var(--Bg-light);
    display: flex;
    align-items: center;
    padding: 0 16px;
    border-bottom: 1px solid var(--Black-20);
    font: var(--medium-22);
    color: var(--Text-primary);

    h2 {
      display: inline-flex;
      align-items: center;
    }

    svg {
      height: 24px;
      width: 24px;
      display: block;
      margin-right: 8px;
    }
  }

  .items {
    padding: 16px;

    li {
      display: flex;
      align-items: center;
      margin: 0 0 12px;
      border-radius: var(--radius);
      padding: 8px;
      background-color: var(--Bg-light);
      cursor: pointer;
      transition: all 0.2s ease;
      border: 1px solid var(--Bg-light);

      img {
        width: 40px;
        height: 40px;
        border-radius: var(--radius);
        margin-right: 8px;
      }

      span {
        font: var(--medium-14);
        color: var(--Text-01);
        flex: 1;
      }

      i {
        color: var(--Text-default);
        width: 16px;
        height: 16px;
        margin-left: 2px;
        display: none;

        svg {
          width: 100%;
          height: 100%;
          transform: rotate(-90deg);
        }
      }

      @at-root {
        body.page-message &.active {
          border-color: var(--Border-primary);

          i {
            display: block;
          }
        }
      }

    }
  }
}
</style>
